import { __extends } from "tslib";
var ErrorBase = /** @class */ (function (_super) {
    __extends(ErrorBase, _super);
    function ErrorBase(message, id, name) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        if (name === void 0) { name = ''; }
        var _this = _super.call(this, message) || this;
        _this._errorID = 0; //Contains the reference number associated with the specific error message.
        _this._messsage = ''; //Contains the message associated with the Error object.
        _this._name = ''; // Contains the name of the Error object.
        _this._messsage = message;
        _this._name = name;
        _this._errorID = id;
        return _this;
    }
    Object.defineProperty(ErrorBase.prototype, "message", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return this._messsage;
        },
        /**
         *
         * @param value
         */
        set: function (value) {
            this._messsage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErrorBase.prototype, "name", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return this._name;
        },
        /**
         *
         * @param value
         */
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ErrorBase.prototype, "errorID", {
        /**
         *
         * @returns {number}
         */
        get: function () {
            return this._errorID;
        },
        enumerable: true,
        configurable: true
    });
    return ErrorBase;
}(Error));
export { ErrorBase };
